export const stepHeadings = {
  initialStepHeading: "Velg spesialitet",
  treatmentStepHeading: "Velg tjeneste",
  appointmentStepHeading: "Ledige timer",
  personalInfoFormStepHeading: "Dine opplysninger",
  bookingConfirmedStepHeading: "Time bestilt!",
}